import jlog from './log'
import { sharePage } from '@/api/Comm'
import wx from 'weixin-js-sdk'
import clipboard from 'clipboard'
import copy from 'copy-to-clipboard'
import { Toast } from 'vant'

export default {
  install(Vue, options) {
    // 1. 添加全局方法或属性
    Vue.myGlobalMethod = function() {
      // 逻辑...
    }

    // unix 时间戳
    Vue.timeStamp = function() {
      return Math.round(new Date().getTime() / 1000)
    }

    /* # 特别注意:此处不能用箭头函数,否则函数内部arguments的作用域就变了  # */
    // 普通日志
    Vue.prototype.$log = function() {
      jlog.log(arguments)
    }
    // 警告日志
    Vue.prototype.$warn = function() {
      jlog.warn(arguments, 'warn')
    }
    // 错误日志
    Vue.prototype.$error = function() {
      jlog.error(arguments, 'error')
    }
    // 打印对象
    Vue.prototype.$dir = function() {
      jlog.dir(arguments, 'dir')
    }

    // 2. 添加全局资源
    Vue.directive('my-directive', {
      bind(el, binding, vnode, oldVnode) {
        // 逻辑...
      }
    })

    // 全局过滤器
    Vue.filter('joinText', function(value, spacer, field) {
      let text = ''
      spacer = spacer || ','
      field = field || 'name'
      try {
        if (Array.isArray(value)) {
          if (value.length > 0 && typeof value[0] === 'object') {
            text = value
              .map(function(n) {
                return n[field]
              })
              .join(spacer)
          } else {
            text = value.join(spacer)
          }
        } else {
          text = JSON.parse(value)
            .map(function(n) {
              return n[field]
            })
            .join(spacer)
        }
      } catch (error) {}
      return text
    })

    // 全局过滤器
    Vue.filter('formJson', function(value) {
      try {
        return JSON.parse(value)
      } catch (error) {
        return null
      }
    })

    // 全局过滤器 defaultNumber
    Vue.filter('dn', function(value, str) {
      str = str || '-'

      if (value == null || value === undefined || value === 0) {
        return str
      } else {
        return value
      }
    })

    // 全局过滤器 对展示空数据进行处理
    Vue.filter('empty', function(value, str) {
      str = str || ''
      if (
        value == null ||
        value === undefined ||
        value === 0 ||
        value === 'undefined'
      ) {
        return ''
      } else {
        return value
      }
    })

    // 3. 注入组件
    Vue.mixin({
      created: function() {
        // 逻辑...
      }
    })
    // 4. 添加实例方法

    // 判断字符是否为空
    Vue.prototype.$isEmpty = function(str) {
      return str === 'undefined' || str == null || str === ''
    }

    // 判断是否为微信
    Vue.prototype.$isWeiXin = function() {
      // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
      return ua.indexOf('micromessenger') > -1
    }

    // 判断是否为支付宝浏览器
    Vue.prototype.$isAlipay = function() {
      if (/AlipayClient/.test(window.navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }

    // 验证手机号
    Vue.prototype.$isPhone = function(phone) {
      const reg = /^1(3|4|5||6|7|8|9)[0-9]{9}$/
      if (reg.test(phone)) {
        return true
      } else {
        return false
      }
    }

    // 验证电话号码
    Vue.prototype.$isTel = function(tel) {
      const reg = /^(\d{3,4}-)\d{7,8}$/
      if (reg.test(tel)) {
        return true
      } else {
        return false
      }
    }

    // 检查字符串是否为合法QQ号码
    Vue.prototype.$isQQ = function(str) {
      // 1 首位不能是0 ^[1-9]
      // 2 必须是 [5, 11] 位的数字 \d{4, 9}
      const reg = /^[1-9][0-9]{4,9}$/gim
      if (reg.test(str)) {
        return true
      } else {
        return false
      }
    }

    // 检查字符串是否为合法Email地址
    Vue.prototype.$isEmail = function(str) {
      const reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
      if (reg.test(str)) {
        return true
      } else {
        return false
      }
    }

    // 去掉前后空格
    Vue.prototype.$trim = function(str) {
      const reg = /^\s+|\s+$/g
      return str.replace(reg, '')
    }

    // 去除字符串的所有空格
    Vue.prototype.$noSpace = function(str) {
      return str.replace(/\s*/g, '')
    }

    // 只允许输入中文汉字和英文字母
    Vue.prototype.$noSpecialTxt = function(str) {
      const re = /[^\u4e00-\u9fa5a-zA-Z0-9]/g
      const res = str.replace(re, '')
      return res
    }

    // 图片地址
    Vue.prototype.$resUrl = function(path) {
      if (
        !path ||
        path.indexOf('http://') > -1 ||
        path.indexOf('https://') > -1
      ) {
        return path
      }
      const baseURL = process.env.VUE_APP_BASE_API
      return baseURL + path
    }

    // 图片资源是否存在
    Vue.prototype.$imgExist = function(imgUrl) {
      return new Promise(function(resolve, reject) {
        const imgObj = new Image()
        imgObj.src = imgUrl
        imgObj.onload = function(res) {
          resolve(res)
        }
        imgObj.onerror = function(err) {
          reject(err)
        }
      })
    }

    // 处理单页内容中图片地址
    Vue.prototype.$resImg = function(content) {
      const baseURL = process.env.VUE_APP_BASE_API
      const objContent = content.replace(
        /<img src="/g,
        `<img style="max-width:100%" src="${baseURL}`
      )
      return objContent
    }

    // 日期转换为指定格式格式
    Vue.prototype.$formatDate = function(date, type) {
      if (!date) {
        return
      }
      const objDate = date.replace(/-/g, type)
      return objDate
    }

    // 图片展示或加载失败显示的默认图片
    Vue.prototype.$defImg = function(src) {
      var img = event.srcElement
      img.src = src
      img.onerror = null
    }

    // 判断图片是否有效
    Vue.prototype.$validateImage = function(pathImg) {
      var ImgObj = new Image()
      ImgObj.src = pathImg
      if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
        return true
      } else {
        return false
      }
    }

    // 判断是否登录
    Vue.prototype.$isLogin = function() {
      if (localStorage.jwtToken) {
        return true
      } else {
        return false
      }
    }

    // 微信分享
    Vue.prototype.$wxShare = function(parms) {
      // eslint-disable-next-line eqeqeq
      if (parms == null || parms == undefined) parms = {}
      parms.url = encodeURIComponent(parms.url || location.href)
      parms.title = parms.title || '万家香火'
      parms.desc = parms.desc || '福瑞众生，孝行万佳'
      parms.imgUrl = parms.imgUrl || `${window.location.origin}/logo.jpg`
      sharePage(parms).then(res => {
        if (res && res.success) {
          var d = res.data
          var sc = d.signature
          var sd = {
            title: d.shareSetting.shareTitle || '',
            desc: d.shareSetting.shareDesc || '',
            link: d.shareSetting.shareLink || '',
            imgUrl: d.shareSetting.shareImg || '',
            success: function() {
              this.$log('分享成功！')
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            }
          }
          wx.config({
            debug: false, // 开启调试模式,
            appId: sc.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: sc.timestamp, // 必填，生成签名的时间戳
            nonceStr: sc.noncestr, // 必填，生成签名的随机串
            signature: sc.signature, // 必填，签名，见附录1
            jsApiList: [
              // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
          wx.ready(function() {
            wx.onMenuShareTimeline(sd)
            wx.onMenuShareAppMessage(sd)
          })
        }
      })
    }

    // 判断设备浏览器
    Vue.prototype.$isiOS = function() {
      const u = navigator.userAgent
      return u.indexOf('iPhone') > -1 || u.indexOf('iOS') > -1
    }

    // 获取当前http地址
    Vue.prototype.$baseUrl = function() {
      const baseURL = process.env.VUE_APP_BASE_API
      return baseURL
    }

    //
    Vue.prototype.$clipboard = clipboard

    // 取消axios请求
    Vue.prototype.$cancelRequest = function() {
      // 获取缓存的 请求取消标识 数组，取消所有关联的请求
      const cancelArr = window.axiosCancel
      cancelArr.forEach((ele, index) => {
        ele.cancel() // 在失败函数中返回这里自定义的错误信息
        delete window.axiosCancel[index]
      })
    }

    /**
     * 复制
     * @param v 目标文本
     * @param n 文本名称
     */
    Vue.prototype.$onCopy = function(v, n) {
      if (copy(v || '')) {
        Toast.success(`${n}复制成功`)
      } else {
        Toast.fail(`${n}复制失败`)
      }
    }

    /**
     * 时间格式转换 72seconds => 00:01:12
     * @param seconds
     */
    Vue.prototype.$formatSeconds = function(seconds) {
      if (seconds <= 0 || !seconds) {
        return '00:00:00'
      }
      let h = parseInt((seconds / 60 / 60 % 24).toString())
      h = h < 10 ? '0' + h : h
      let m = parseInt((seconds / 60 % 60).toString())
      m = m < 10 ? '0' + m : m
      let s = parseInt((seconds % 60).toString())
      s = s < 10 ? '0' + s : s
      return `${h}:${m}:${s}`
    }
  }
}
